import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    workEmail: '',
    phoneNumber: '',
    helpWith: '',
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    // console.log('Form Data:', formData);
    // alert('Thank you! Your message has been submitted.');
  };

  return (
    <div className="form-container-card">
      <form onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label htmlFor="workEmail">Work Email *</label>
          <input
            id="workEmail"
            name="workEmail"
            type="email"
            placeholder="* Your business email"
            required
            value={formData.workEmail}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number:</label>
          <div className="phone-input-container">
            <select className="country-code-selector" aria-label="Country code">
              <option>🌐</option>
              {/* This can be populated with a library or a list of countries */}
            </select>
            <input
              id="phoneNumber"
              name="phoneNumber"
              type="tel"
              value={formData.phoneNumber}
              onChange={handleChange}
              aria-label="Phone number"
            />
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="helpWith">What can we help with? *</label>
          <textarea
            id="helpWith"
            name="helpWith"
            rows="5"
            required
            value={formData.helpWith}
            onChange={handleChange}
          />
        </div>

        <div className="form-group-checkbox">
          <input
            id="consent"
            name="consent"
            type="checkbox"
            checked={formData.consent}
            onChange={handleChange}
          />
          <label htmlFor="consent">I consent to receive marketing messages from Sendbird.</label>
        </div>
        
        <p className="privacy-text">
          By clicking “Submit” I agree to Sendbird’s <a href="#privacy">Privacy Policy</a>.
        </p>

        <button type="submit" className="submit-button">
          CONTACT US
        </button>
      </form>
    </div>
  );
};

export default ContactForm;